import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select/src/tom-select.popular'
import { TomInput, TomOption } from 'tom-select/src/types'
import { escape_html } from 'tom-select/src/utils'
import removeButton from 'tom-select/src/plugins/remove_button/plugin'

TomSelect.define('remove_button', removeButton)

const chevronIcon =
  '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5">' +
  '<path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />' +
  '</svg>'

interface UserTomOption extends TomOption {
  avatar: string
  text: string
}

export default class extends Controller {
  static values = {
    keepLastValue: { type: Boolean, default: false },
    icon: { type: Boolean, default: false },
    dropdownParent: { type: String, default: '' }
  }

  declare keepLastValueValue: boolean
  declare iconValue: boolean
  declare dropdownParentValue: string
  plugin: TomSelect

  connect (): void {
    this.initTomSelect()
  }

  disconnect (): void {
    if (!document.body.contains(this.element)) {
      this.plugin?.destroy()
    }
  }

  private initTomSelect (): void {
    const isMultiple = (this.element as HTMLSelectElement).multiple
    const tomSelectOptions: Record<string, unknown> = {
      plugins: isMultiple ? ['remove_button'] : [],
      onDelete: (values: string[]) => {
        if (!this.keepLastValueValue) return true
        return (this.plugin.items.length - values.length) > 0
      },
      render: {
        option: (data: UserTomOption, escape: typeof escape_html) => this.renderOption(data, escape),
        item: (data: UserTomOption, escape: typeof escape_html) => this.renderOption(data, escape)
      }
    }

    if (this.dropdownParentValue === 'body') {
      tomSelectOptions.dropdownParent = 'body'
      tomSelectOptions.hideSelected = isMultiple
      if (!isMultiple) tomSelectOptions.closeAfterSelect = true
    }

    this.plugin = new TomSelect(
      this.element as TomInput,
      tomSelectOptions as ConstructorParameters<typeof TomSelect>[1]
    )

    ;(this.element as HTMLElement & { tomSelect?: TomSelect }).tomSelect = this.plugin

    if (this.iconValue) {
      this.plugin.wrapper.classList.add('with-chevron')
      if (this.plugin.control.querySelector('.ts-chevron') == null) {
        this.plugin.control.insertAdjacentHTML('beforeend', `<span class="ts-chevron">${chevronIcon}</span>`)
      }
    }
  }

  private renderOption (data: UserTomOption, escape: typeof escape_html): string {
    const hasAvatar = data.avatar != null && data.avatar !== '' && data.avatar !== 'undefined'
    const avatar = hasAvatar ? `<span class="inline-flex">${data.avatar}</span>` : ''
    const itemClass = hasAvatar ? 'item-with-avatar' : ''

    return `<div class="${itemClass}">${avatar}<span>${escape(data.text)}</span></div>`
  }
}
